export default "__VITE_ASSET__ruReS3oG__"